import { useNotification } from 'components/Notification';
import { useEffect, useRef } from 'react';
import { useEventTracking } from 'state/eventTracking';
import useCreateAdStatusQueryParams from './useCreateAdStatusQueryParams';

export interface UseCheckCreateAdStatusConfig {
  onSuccess?: () => void;
  onCancel?: (selfServeSponsorRequestId: number | null) => void;
}

const useCheckCreateAdStatus = ({
  onSuccess,
  onCancel,
}: UseCheckCreateAdStatusConfig) => {
  const isCheckoutResponseReceivedRef = useRef(false);

  const { checkoutResponse, selfServeSponsorRequestId } =
    useCreateAdStatusQueryParams();
  const { trackCreatePromoCheckout } = useEventTracking();
  const { showError } = useNotification();

  useEffect(() => {
    if (isCheckoutResponseReceivedRef.current) {
      return;
    }

    if (checkoutResponse === 'success') {
      isCheckoutResponseReceivedRef.current = true;

      onSuccess?.();
    } else if (checkoutResponse === 'cancel') {
      isCheckoutResponseReceivedRef.current = true;

      showError('Something went wrong.');
      trackCreatePromoCheckout(false);
      onCancel?.(selfServeSponsorRequestId);
    }
  }, [
    checkoutResponse,
    selfServeSponsorRequestId,
    onSuccess,
    onCancel,
    showError,
    trackCreatePromoCheckout,
  ]);
};

export default useCheckCreateAdStatus;
